import {Directive, DoCheck, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[cepMask]'
})
export class CepMaskDirective implements DoCheck {

  constructor(private ngControl: NgControl) {}

  ngDoCheck() {
    const control = this.ngControl.control;
    if (control && control.value != null) {
      this.aplicarMascara(control.value);
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    this.aplicarMascara(event.target.value || '');
  }

  private aplicarMascara(valor: any) {
    const value = String(valor).replace(/\D/g, '').substring(0, 8)
      .replace(/(\d{5})(\d)/, '$1-$2');

    const control = this.ngControl.control;
    if (control && control.value !== value) {
      control.setValue(value, { emitEvent: false });
    }
  }
}
